module.exports = __webpack_public_path__ + "static/Loews-Ad-Large-5be8060428e6179abb77d32ab48fdf12.jpg";